var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "plan", attrs: { name: "subscriptionPlan" } },
    [
      _c("div", { staticClass: "plan__title" }, [
        _vm._v(_vm._s(_vm.$t("paywall.title")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "plan__card" }, [
        _c("img", {
          attrs: { src: _vm.mediaBaseUrl + "paywall/card.png", alt: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("paywall.plan.card.title")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "price" }, [_vm._v(_vm._s(_vm.planPrice))]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("paywall.plan.card.text")))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.oneClickProvider == "googlePay" || _vm.oneClickProvider == "applePay"
        ? _c(
            "button",
            {
              class:
                _vm.oneClickProvider == "googlePay"
                  ? "google-pay-btn"
                  : "apple-pay-btn",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.showPaymentRequest.apply(null, arguments)
                }
              }
            },
            [
              _vm._v("\n    " + _vm._s(_vm.$t("paywall.buyWith")) + "\n    "),
              _vm.oneClickProvider == "googlePay"
                ? _c("img", {
                    attrs: {
                      src: _vm.mediaBaseUrl + "paywall/google-pay.svg",
                      width: "53px",
                      height: "53px"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.oneClickProvider == "applePay"
                ? _c("img", {
                    attrs: {
                      src: _vm.mediaBaseUrl + "paywall/apple-pay-logo.png",
                      width: "44px",
                      height: "19px"
                    }
                  })
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.showPaymentForm
        ? _c(
            "button",
            { staticClass: "credit-card-btn", on: { click: _vm.scrollTo } },
            [_vm._v("\n    " + _vm._s(_vm.$t("paywall.payWithCard")) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showPaymentForm
        ? _c("paywall-payment-form", {
            attrs: { oneClickProvider: _vm.oneClickProvider }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showPaymentForm
        ? _c("div", { staticClass: "guarantee" }, [
            _c("div", { staticClass: "guarantee__title" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("paywall.guarantee.title")) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "guarantee__text" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("paywall.guarantee.text")) + "\n    "
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }